import type { AuthorityType, EventCategory, PresidentialActionRecord } from '../types/simulation.js';

export interface PresidentialActionTemplate {
  id: string;
  actionType: PresidentialActionRecord['actionType'];
  label: string;
  description: string;
  authority: AuthorityType;
  category: EventCategory;
  delayHours: number;
  legalRisk: number;
  politicalRisk: number;
  costLabel?: string;
  requiredActorIds: string[];
  effect?: { key: 'administrativeCapacity' | 'congressionalCooperation' | 'legalExposure' | 'marketConfidence' | 'globalTension'; delta: number; reason: string };
}

export const PRESIDENTIAL_ACTIONS: PresidentialActionTemplate[] = [
  {
    id: 'eo-coordination', actionType: 'executive_order', label: 'Executive Order — coordination interagences',
    description: 'Oriente l’exécutif vers une coordination renforcée. L’ordre ne crée pas de crédits et peut être contesté s’il dépasse l’autorité disponible.',
    authority: 'PRESIDENTIAL_AUTHORITY', category: 'gouvernement', delayHours: 24, legalRisk: 18, politicalRisk: 14, costLabel: 'Coût administratif modéré', requiredActorIds: ['president'],
    effect: { key: 'administrativeCapacity', delta: 1.1, reason: 'Mise en œuvre progressive d’un ordre de coordination' }
  },
  {
    id: 'memo-regulatory-review', actionType: 'memorandum', label: 'Memorandum — revue réglementaire',
    description: 'Demande à OMB et aux agences de revoir un ensemble de règles. Les effets dépendent des autorités statutaires de chaque agence.',
    authority: 'AGENCY_ACTION', category: 'gouvernement', delayHours: 72, legalRisk: 12, politicalRisk: 10, costLabel: 'Faible coût administratif', requiredActorIds: ['president'],
    effect: { key: 'administrativeCapacity', delta: 0.5, reason: 'Travail de revue réglementaire coordonné par OMB' }
  },
  {
    id: 'proclamation-civic', actionType: 'proclamation', label: 'Proclamation civique',
    description: 'Action principalement cérémonielle. Effet politique limité et non garanti.',
    authority: 'PRESIDENTIAL_AUTHORITY', category: 'presidence', delayHours: 1, legalRisk: 1, politicalRisk: 4, requiredActorIds: ['president']
  },
  {
    id: 'directive-security-review', actionType: 'directive', label: 'Directive — revue de posture de sécurité',
    description: 'Demande un examen interagences. Ce n’est pas un ordre de guerre et aucune force n’est déployée automatiquement.',
    authority: 'SHARED_AUTHORITY', category: 'defense', delayHours: 48, legalRisk: 8, politicalRisk: 12, requiredActorIds: ['president', 'intelligenceCommunity'],
    effect: { key: 'globalTension', delta: 0.2, reason: 'Signal externe limité lié à une revue de posture' }
  },
  {
    id: 'pardon-federal', actionType: 'pardon', label: 'Décider une grâce fédérale préparée',
    description: 'Décide un dossier fictif de grâce fédérale déjà instruit. La décision est présidentielle; les effets politiques ne sont pas garantis.',
    authority: 'PRESIDENTIAL_AUTHORITY', category: 'institutions', delayHours: 96, legalRisk: 5, politicalRisk: 22, requiredActorIds: ['president']
  },
  {
    id: 'travel-domestic', actionType: 'travel', label: 'Programmer un déplacement présidentiel',
    description: 'Crée une préparation logistique et consomme de l’attention. Aucun gain de popularité n’est automatique.',
    authority: 'PRESIDENTIAL_AUTHORITY', category: 'presidence', delayHours: 120, legalRisk: 1, politicalRisk: 6, costLabel: 'Mobilisation logistique', requiredActorIds: ['president']
  }
];
